import Box from "@mui/material/Box";
import { useGenerateCampaignFormMeta } from "../../../../hooks/platforms/meta/useGenerateCampaignFormMeta";
import AnswerContainer from "../../../TypeForm/AnswerContainer";
import AnswerContainerTitleAndField from "../../../TypeForm/AnswerContainerTitleAndField";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormHelperText,
  LinearProgress,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
  TextField as TextFieldMUI,
} from "@mui/material";
import { Trash2 } from "lucide-react";
import AnswerTitle from "../../../TypeForm/AnswerTitle";
import AnswerSubTitle from "../../../TypeForm/AnswerSubtitle";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import ActionsButtons from "../../../TypeForm/ActionsButtons";
import { useTranslationApp } from "../../../../lib/i18next";
import { useSelectorApp } from "../../../../lib/redux";
import Select from "../../../Form/Select";
import {
  optionsAdsCampaignObjectivesMeta,
  optionsAppPromotion,
} from "../../../../utils/options";
import {
  AD_ACCOUNT_META_PLACEHOLDER,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  BUTTON_CANCEL,
  BUTTON_CONTINUE,
  CATALOG_PLACEHOLDER,
  CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER,
  CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  ERROR_OCCURRED,
  INSTAGRAM_ACCOUNT_PLACEHOLDER,
  PAGE_FACEBOOK_PLACEHOLDER,
  OPTIONAL,
  SELECT_A_OPTION,
  START_DATE_PLACEHOLDER,
  TRACKING_META_ID_PLACEHOLDER,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  VALUE_EXPRESSED_IN,
  PRODUCT_URL_PLACEHOLDER,
  PRODUCT_LABEL,
  SERVICE_URL_PLACEHOLDER,
  SERVICE_LABEL,
  BUTTON_SELECT_CONTENT,
  SUGGESTED_CREATIVES_COUNT,
  FIELD_REQUIRED,
  META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL,
  CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL,
} from "../../../../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  BORDER_RADIUS,
  DELAY_DEBOUNCE,
  FORMATS_MEDIA_META,
  META,
  metaCurrenciesWithDecimals,
  MIN_DIMENSIONS_CONTENT,
  ADS_CAMPAIGN_TEMPLATE_SINGULAR_OPTION,
  ADS_CAMPAIGN_TEMPLATE_MULTIPLE_OPTION,
  BUSINESS_OFFERING_PHYSICAL_PRODUCT,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED,
  ADS_CAMPAIGN_CAROUSEL_FORMAT,
  LABELS_TRACKING_CUSTOM_EVENTS,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
} from "../../../../utils/constants";
import { hasInstagramAccountsConnected } from "../../../../utils/meta";
import SelectDestinationTypeMeta from "../../../Meta/SelectDestinationTypeMeta";
import SelectInstagramAccount from "../../../Meta/SelectInstagramAccount";
import SelectPageFacebook from "../../../Meta/SelectPageFacebook";
import SelectBusinessAccount from "../../../Meta/SelectBusinessAccount";
import SelectTrackingIDField from "../../../Form/SelectTrackingIDField";
import SelectCustomEventAds from "../../../Form/SelectCustomEventAds";
import TextField from "../../../Form/TextField";
import DateField from "../../../Form/DateField";
import { addDays, startOfDay } from "date-fns";
import MediaUrlsAnalysisContainer from "../../../Common/MediaUrlsAnalysisContainer";
import _ from "lodash";
import NumberField from "../../../Form/NumberField";
import { ConfirmAlert } from "../../../Alerts/Alerts";
import NumberDecimalField from "../../../Form/NumberDecimalField";
import { useDispatchApp } from "../../../../lib/redux";
import {
  startGetAudienceProjectionAdsCampaign,
  startGetSuggestedCreativesByBudgetAdsCampaign,
} from "../../../../actions/adsCampaigns";
import { useDebounced } from "../../../../hooks/useDebounce";
import SelectCatalogMeta from "../Campaign/SelectCatalogMeta";
import SelectAdvertisableAppsMeta from "../Ad/SelectAdvertisableAppsMeta";
import endOfDay from "date-fns/endOfDay";
import {
  BOX_SHADOW_FIELDS,
  INPUT_COLOR_BORDER,
  GRAY_50,
  GRAY_200,
  GRAY_900,
} from "../../../../utils/colors";
import IconButtonAddContent from "../../../Buttons/IconButtonAddContent";
import {
  formatMediaUrl,
  getIsCarouselAdIsAvailable,
} from "../../../../services/adsCampaigns";
import { getPathDatabaseByRole } from "../../../../actions/auth";
import IconButton from "../../../Buttons/IconButton";
import { REGEX_URL } from "../../../../utils/regex";
import { useHydratePendingGalleryCreatives } from "../../../../hooks/useHydratePendingGalleryCreatives";

const GenerateCampaignFormMeta = ({
  initialData = {},
  campaignID,
  generatedPlatforms = {},
  context = {},
  galleryHydrationRef,
  onCallbackSave = () => {},
  onExitToPlatformSelection,
  verifyBlockAlert,
  resumeValues = null,
}) => {
  const config = useGenerateCampaignFormMeta({
    ...context,
    campaignID,
    generatedPlatforms,
    onCallbackSave,
    onExitToPlatformSelection,
    verifyBlockAlert,
    resumeValues,
  });
  const currentAnswer = config.currentAnswer;
  const fieldsConfig = config.fields;
  const { setValue, getValues } = config.utils;
  const steps = config.steps;
  const isLoadingDefaults = config.isLoadingDefaults;

  useEffect(() => {
    if (isLoadingDefaults || _.isEmpty(initialData)) return;

    Object.keys(initialData).forEach((key) => {
      if (key === "destinationURL" && initialData?.[key]) {
        setValue("destinationURL", initialData?.[key]);
      }
      if (
        key === "objective" &&
        initialData[key] &&
        optionsAdsCampaignObjectivesMeta.find(
          (option) => option.value === initialData?.[key]
        )
      ) {
        setValue("objective", initialData?.[key]);
      }
    });
    // eslint-disable-next-line
  }, [initialData, isLoadingDefaults]);

  useHydratePendingGalleryCreatives({
    initialData,
    isLoadingDefaults,
    currentAnswer,
    creativeStepName: "mediaUrls",
    fieldName: "mediaUrls",
    platformKey: META,
    galleryHydrationRef,
    setValue,
    getValues,
    acceptedFormats: FORMATS_MEDIA_META,
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 400,
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {steps.map((step) => {
          const fieldConfig = fieldsConfig[step];
          if (!fieldConfig.isVisible || currentAnswer !== fieldConfig.name)
            return null;

          return (
            <CommonQuestionContainer
              key={fieldConfig.name}
              formConfig={config}
              fieldConfig={fieldConfig}
              context={context}
            />
          );
        })}
      </Box>
    </Box>
  );
};

const ObjectiveQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { setValue } = fieldConfig.utils;
  const { watch } = fieldConfig.utils;
  const currentDestinationType = watch(`destinationType`);
  const currentObjective = watch(`objective`);
  const mediaUrls = watch(`mediaUrls`);

  const isCurrentDestinationTypePostEngagement =
    currentDestinationType ===
      ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
    currentObjective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION;

  const validationChange = async (newObjective) => {
    if (
      isCurrentDestinationTypePostEngagement &&
      newObjective !== currentObjective &&
      mediaUrls?.length > 0
    ) {
      const result = await ConfirmAlert({
        title: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE
        ),
        text: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION
        ),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });

      if (!result.isConfirmed) return false;

      setValue(`mediaUrls`, []);
    }

    return true;
  };

  return (
    <Select
      options={optionsAdsCampaignObjectivesMeta}
      name={fieldConfig.name}
      variant="filled"
      fullWidth
      label={t(SELECT_A_OPTION)}
      doTranslate={true}
      control={control}
      validationChange={validationChange}
      actionsChange={() => {
        setValue(
          `destinationType`,
          ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
        );
        setValue(`catalogID`, "");
        setValue(`trackingID`, "");
        setValue(`trackingOfflineID`, "");
        setValue(`trackingCustomEventID`, "");
      }}
    />
  );
};

const AppPromotionQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { setValue } = fieldConfig.utils;

  return (
    <Select
      options={optionsAppPromotion}
      name={fieldConfig.name}
      variant="filled"
      fullWidth
      label={t(SELECT_A_OPTION)}
      doTranslate={true}
      control={control}
      actionsChange={(value) => {
        if (value === ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION) {
          setValue("isIOS14Campaign", true);
        } else {
          setValue("isIOS14Campaign", false);
        }
      }}
    />
  );
};

const DestinationTypeQuestion = ({ fieldConfig, control }) => {
  const { watch, setValue } = fieldConfig.utils;
  const objective = watch("objective");
  const currentDestinationType = watch("destinationType");
  const mediaUrls = watch("mediaUrls");

  const { t } = useTranslationApp();

  const validationChange = async (newDestinationType) => {
    if (
      ((currentDestinationType ===
        ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
        newDestinationType !==
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION) ||
        (currentDestinationType !==
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
          newDestinationType ===
            ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION)) &&
      mediaUrls.length > 0
    ) {
      const result = await ConfirmAlert({
        title: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE
        ),
        text: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION
        ),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });

      if (!result.isConfirmed) return false;

      setValue(`mediaUrls`, []);
    }

    return true;
  };

  return (
    <SelectDestinationTypeMeta
      control={control}
      name={fieldConfig.name}
      fullWidth
      variant="filled"
      placeholder={SELECT_A_OPTION}
      objective={objective}
      validationChange={validationChange}
      actionsChange={() => {
        setValue(`catalogID`, "");
        setValue(`useFBPageAsIG`, false);
        setValue(`trackingID`, "");
        setValue(`trackingOfflineID`, "");
        setValue(`trackingCustomEventID`, "");
      }}
      from="campaign"
    />
  );
};

const IdentitiesQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { setValue } = fieldConfig.utils;
  const { integrations } = useSelectorApp((state) => state.user);

  const [integrationID, adAccountID, pageID, destinationType] = useWatch({
    control,
    name: ["integrationID", "adAccountID", "pageID", "destinationType"],
  });

  const hasInstagramAccounts = hasInstagramAccountsConnected(
    integrations,
    integrationID,
    pageID
  );
  const isInstagramRequired =
    destinationType &&
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED.includes(
      destinationType
    );
  const instagramLabel =
    hasInstagramAccounts || isInstagramRequired
      ? t(INSTAGRAM_ACCOUNT_PLACEHOLDER)
      : `${t(INSTAGRAM_ACCOUNT_PLACEHOLDER)} (${t(OPTIONAL)})`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <SelectBusinessAccount
        variant="filled"
        label={t(AD_ACCOUNT_META_PLACEHOLDER)}
        control={control}
        platform={META}
        name={`adAccountID`}
        onChangeAction={(value) => {
          setValue(`integrationID`, value?.integrationID);
          setValue(`trackingID`, "");
          setValue(`pageID`, "");
          setValue(`instagramID`, "");
          setValue(`useFBPageAsIG`, false);
          setValue(`budget`, "");
          setValue(`catalogID`, "");
          setValue(`trackingCustomEventID`, "");
        }}
        fullWidth={true}
      />
      <SelectPageFacebook
        variant="filled"
        control={control}
        integrationID={integrationID}
        adAccountID={adAccountID}
        name={`pageID`}
        onChangeAction={() => {
          setValue(`useFBPageAsIG`, false);
          setValue(`instagramID`, "");
        }}
        label={t(PAGE_FACEBOOK_PLACEHOLDER)}
        fullWidth={true}
        sxTextField={{
          backgroundColor: "fields.background",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        }}
      />
      <Box>
        <SelectInstagramAccount
          variant="filled"
          control={control}
          integrationID={integrationID}
          adAccountID={adAccountID}
          pageID={pageID}
          name={`instagramID`}
          nameUseFBPageAsIG="useFBPageAsIG"
          label={instagramLabel}
          fullWidth={true}
          isInstagramRequired={isInstagramRequired}
          sxTextField={{
            backgroundColor: "fields.background",
            border: `1px solid ${INPUT_COLOR_BORDER}`,
            boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        />
      </Box>
      <Typography variant="body2" color="text.secondary">
        {t(META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT)}
      </Typography>
    </Box>
  );
};

const TrackingIDQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { getValues, watch, setValue } = fieldConfig.utils;

  const integrationID = getValues(`integrationID`);
  const adAccountID = getValues(`adAccountID`);
  const destinationType = watch(`destinationType`);
  const objective = watch(`objective`);
  const trackingID = watch(`trackingID`);
  const hasTrackingCustomEventID =
    (destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION &&
      ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective)) ||
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION ||
    (destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION &&
      objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        width: "100%",
      }}
    >
      <SelectTrackingIDField
        control={control}
        name={fieldConfig.name}
        label={t(TRACKING_META_ID_PLACEHOLDER)}
        fullWidth
        variant="filled"
        platform={META}
        integrationID={integrationID}
        adAccountID={adAccountID}
        onChangeAction={() => {
          setValue("trackingCustomEventID", "");
        }}
      />

      {hasTrackingCustomEventID && (
        <SelectCustomEventAds
          name="trackingCustomEventID"
          platform={META}
          variant="filled"
          label={t(LABELS_TRACKING_CUSTOM_EVENTS[META])}
          integrationID={integrationID}
          adAccountID={adAccountID}
          trackingID={trackingID}
          objective={objective}
          isCatalogCampaign={
            destinationType ===
            ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION
          }
          control={control}
          fullWidth={true}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
        />
      )}

      {ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
        destinationType
      ) && (
        <SelectTrackingIDField
          control={control}
          name="trackingOfflineID"
          label={t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
          fullWidth
          variant="filled"
          platform={META}
          integrationID={integrationID}
          adAccountID={adAccountID}
        />
      )}
    </Box>
  );
};

const CatalogIDQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { getValues } = fieldConfig.utils;

  const integrationID = getValues(`integrationID`);
  const adAccountID = getValues(`adAccountID`);

  return (
    <SelectCatalogMeta
      control={control}
      name={fieldConfig.name}
      label={t(CATALOG_PLACEHOLDER)}
      fullWidth
      variant="filled"
      platform={META}
      integrationID={integrationID}
      adAccountID={adAccountID}
    />
  );
};

const AppIDQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { getValues } = fieldConfig.utils;

  const integrationID = getValues(`integrationID`);
  const adAccountID = getValues(`adAccountID`);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <SelectAdvertisableAppsMeta
        placeholder={t(SELECT_A_OPTION)}
        platform={META}
        adAccountID={adAccountID}
        integrationID={integrationID}
        name={fieldConfig.name}
        fullWidth
        variant="filled"
        control={control}
      />
    </Box>
  );
};

const DestinationURLQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();

  return (
    <TextField
      control={control}
      name={fieldConfig.name}
      fullWidth
      placeholder={t(CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER)}
      variant="filled"
    />
  );
};

const TypeBudgetQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();

  return (
    <Controller
      control={control}
      name={fieldConfig.name}
      rules={{
        required: { value: true, message: t(FIELD_REQUIRED) },
      }}
      render={({ field, fieldState }) => (
        <FormControl
          component="fieldset"
          variant="standard"
          fullWidth
          error={!!fieldState.error}
        >
          <RadioGroup
            sx={{ gap: 1 }}
            value={field.value ?? ""}
            onChange={(e) => {
              field.onChange(e.target.value);
            }}
          >
            <FormControlLabel
              value={ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION}
              control={<Radio />}
              label={t(CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL)}
            />
            <FormControlLabel
              value={ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION}
              control={<Radio />}
              label={t(CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL)}
            />
          </RadioGroup>
          {fieldState.error?.message ? (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          ) : null}
        </FormControl>
      )}
    />
  );
};

const BudgetQuestion = ({ fieldConfig, control, currency, context }) => {
  const { t } = useTranslationApp();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <TextField
        control={control}
        name={fieldConfig.name}
        placeholder={t(CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER)}
        fullWidth
        variant="filled"
        InputProps={{
          inputComponent: metaCurrenciesWithDecimals.includes(currency)
            ? NumberDecimalField
            : NumberField,
        }}
        helperText={t(VALUE_EXPRESSED_IN, {
          currency,
        })}
      />

      <Projection
        fieldConfig={fieldConfig}
        context={context}
        currency={currency}
      />
    </Box>
  );
};

const DatesQuestion = ({ fieldConfig, control }) => {
  const { t } = useTranslationApp();
  const { watch, setValue } = fieldConfig.utils;
  const startDate = watch("startDate");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <DateField
        sx={{
          backgroundColor: "fields.background",
          boxShadow: BOX_SHADOW_FIELDS,
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          borderRadius: BORDER_RADIUS,
        }}
        variant="filled"
        name="startDate"
        label={t(START_DATE_PLACEHOLDER)}
        actionsChange={() => {
          setValue("endDate", null);
        }}
        control={control}
        minDate={startOfDay(new Date())}
        showStartNowButton={true}
      />
      <DateField
        sx={{
          backgroundColor: "fields.background",
          boxShadow: BOX_SHADOW_FIELDS,
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          borderRadius: BORDER_RADIUS,
        }}
        variant="filled"
        name="endDate"
        defaultCalendarMonth={addDays(startDate || new Date(), 1)}
        actionsChange={(value) => {
          setValue(`endDate`, value ? endOfDay(value) : null);
        }}
        label={t(END_DATE_PLACEHOLDER)}
        control={control}
        minDate={addDays(startDate || new Date(), 1)}
      />
    </Box>
  );
};

const MediaUrlsQuestion = ({ fieldConfig, currency }) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [suggestedCreativesCount, setSuggestedCreativesCount] = useState(null);
  const hasFetchedSuggestedCreativesRef = useRef(false);
  const { setValue, getValues, watch } = fieldConfig.utils;
  const mediaUrls = watch("mediaUrls") || [];
  const objective = watch("objective");
  const context = watch("context");
  const template = watch("template");
  const multipleItems = watch("multipleItems") || [];

  useEffect(() => {
    if (hasFetchedSuggestedCreativesRef.current) return;

    const budget = getValues("budget");
    const typeBudget = getValues("typeBudget");
    const startDate = getValues("startDate");
    const endDate = getValues("endDate");

    const shouldSkip =
      !budget || !typeBudget || !currency || fieldConfig.name !== "mediaUrls";

    if (shouldSkip) return;

    hasFetchedSuggestedCreativesRef.current = true;
    setSuggestedCreativesCount(null);

    const fetchSuggestedCreatives = async () => {
      const response = await dispatch(
        startGetSuggestedCreativesByBudgetAdsCampaign({
          platform: META,
          budget,
          typeBudget,
          currency,
          startDate,
          endDate,
        })
      );

      const count =
        response.ok && response.data?.suggestedCreativesByBudget
          ? response.data.suggestedCreativesByBudget
          : null;

      setSuggestedCreativesCount(count);
    };

    fetchSuggestedCreatives();
  }, [currency, dispatch, fieldConfig.name, getValues]);

  const mediaUrlsAnalysisRef = useRef(null);

  const onCallbackCampaignMediaImport = ({ entries }) => {
    if (!entries?.length) return;
    const current = getValues("mediaUrls") || [];
    setValue("mediaUrls", [...current, ...entries]);
    requestAnimationFrame(() => {
      mediaUrlsAnalysisRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  // Use URL as identifier to avoid sync issues with async operations
  const onChangeItem = ({ url, data = {} }) => {
    const currentMediaUrls = getValues("mediaUrls");
    // Find item by URL (for individual items) or by carousel identifier
    const index = currentMediaUrls.findIndex((item) => {
      if (item?.isCarousel && item?.carouselImages) {
        // For carousels, check if any carouselImage matches the URL
        return item.carouselImages.some((img) => {
          const imgUrl = typeof img === "string" ? img : img?.url;
          return imgUrl === url;
        });
      }
      return item?.url === url;
    });
    if (index === -1) return; // Element no longer exists, ignore update
    const currentData = currentMediaUrls[index];
    if (!currentData) return; // Safety check
    const newData = {
      ...currentData,
      ...data,
    };
    setValue(`mediaUrls.[${index}]`, newData);
  };
  const onRemoveItem = (index) => {
    setValue(
      "mediaUrls",
      mediaUrls.filter((_, i) => i !== index)
    );
  };

  const isMultipleTemplate = template === ADS_CAMPAIGN_TEMPLATE_MULTIPLE_OPTION;
  const hasMultipleItemsContent =
    multipleItems?.length > 0 &&
    multipleItems.some((item) => item?.mediaUrls?.length > 0);
  const hasContent = isMultipleTemplate
    ? hasMultipleItemsContent
    : mediaUrls?.length > 0;
  const shouldShowSuggestedCreativesHint =
    suggestedCreativesCount !== null && !hasContent && !isMultipleTemplate;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        position: "relative",
      }}
    >
      {isMultipleTemplate ? (
        <EcommerceProductsQuestion
          fieldConfig={fieldConfig}
          suggestedCreativesCount={suggestedCreativesCount}
        />
      ) : (
        <MediaUrlsAnalysisContainer
          containerRef={mediaUrlsAnalysisRef}
          mediaUrls={mediaUrls}
          onRemoveItem={onRemoveItem}
          onChangeItem={onChangeItem}
          objective={objective}
          campaignContext={context}
          platform={META}
          suggestedCreativesCount={suggestedCreativesCount}
          onCallbackCampaignMediaImport={onCallbackCampaignMediaImport}
        />
      )}
      {shouldShowSuggestedCreativesHint && (
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            textAlign: "center",
            color: "text.secondary",
            position: "absolute",
            bottom: -145,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          {t(SUGGESTED_CREATIVES_COUNT, {
            count: suggestedCreativesCount,
          })}
        </Typography>
      )}
    </Box>
  );
};

const EcommerceProductsQuestion = ({
  fieldConfig,
  suggestedCreativesCount,
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const {
    setValue,
    getValues,
    watch,
    campaignID,
    campaignContext,
    language,
    businessOffering,
  } = fieldConfig.utils;
  const lastItemRef = useRef(null);
  const previousLengthRef = useRef();
  const multipleItems = watch("multipleItems");
  const integrationID = getValues("integrationID");
  const adAccountID = getValues("adAccountID");
  const pageID = getValues("pageID");
  const destinationType = getValues("destinationType");

  const isCarouselAdsAvailable = getIsCarouselAdIsAvailable({
    platform: META,
    destinationType,
  });

  const isPhysicalProduct =
    businessOffering === BUSINESS_OFFERING_PHYSICAL_PRODUCT;

  const { userID } = dispatch(getPathDatabaseByRole());

  const onRemoveProduct = (index) => {
    if (multipleItems.length <= 1) {
      setValue("template", ADS_CAMPAIGN_TEMPLATE_SINGULAR_OPTION);
      setValue("multipleItems", [{ destinationUrl: "", mediaUrls: [] }]);
      return;
    }
    setValue(
      "multipleItems",
      multipleItems.filter((_, i) => i !== index)
    );
  };

  const onChangeProductUrl = (index, url) => {
    const updatedItems = [...multipleItems];
    updatedItems[index] = {
      ...updatedItems[index],
      destinationUrl: url,
    };
    setValue("multipleItems", updatedItems);
  };

  const onAddMediaUrl = (index, contents) => {
    const updatedItems = [...multipleItems];
    const contentsFormatted = contents.map((content) =>
      formatMediaUrl(content)
    );
    updatedItems[index] = {
      ...updatedItems[index],
      mediaUrls: [...updatedItems[index].mediaUrls, ...contentsFormatted],
    };
    setValue("multipleItems", updatedItems);
  };

  const onRemoveMediaUrl = (itemIndex, mediaIndex) => {
    const updatedItems = [...multipleItems];
    updatedItems[itemIndex] = {
      ...updatedItems[itemIndex],
      mediaUrls: updatedItems[itemIndex].mediaUrls.filter(
        (_, i) => i !== mediaIndex
      ),
    };
    setValue("multipleItems", updatedItems);
  };

  const onChangeMediaUrlItem = (itemIndex, mediaIndex, data) => {
    const updatedItems = [...multipleItems];
    const currentMediaUrl = updatedItems[itemIndex].mediaUrls[mediaIndex];
    updatedItems[itemIndex].mediaUrls[mediaIndex] = {
      ...currentMediaUrl,
      ...data,
    };
    setValue("multipleItems", updatedItems);
  };

  useEffect(() => {
    if (previousLengthRef.current === undefined) {
      previousLengthRef.current = multipleItems?.length || 0;
      return;
    }
    const currentLength = multipleItems?.length || 0;
    if (currentLength > previousLengthRef.current) {
      requestAnimationFrame(() => {
        lastItemRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      });
    }
    previousLengthRef.current = currentLength;
  }, [multipleItems]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        width: "100%",
        mt: 2,
        pb: 1,
      }}
    >
      {multipleItems.map((item, itemIndex) => (
        <Box
          key={itemIndex}
          ref={itemIndex === multipleItems.length - 1 ? lastItemRef : undefined}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            p: 2,
            border: `1px solid ${INPUT_COLOR_BORDER}`,
            borderRadius: BORDER_RADIUS,
            backgroundColor: "fields.background",
            boxShadow: BOX_SHADOW_FIELDS,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold">
              {t(isPhysicalProduct ? PRODUCT_LABEL : SERVICE_LABEL, {
                number: itemIndex + 1,
              })}
            </Typography>
            <IconButton size="small" onClick={() => onRemoveProduct(itemIndex)}>
              <Trash2 size={18} />
            </IconButton>
          </Box>

          <TextFieldMUI
            value={item.destinationUrl}
            onChange={(e) => onChangeProductUrl(itemIndex, e.target.value)}
            placeholder={t(
              isPhysicalProduct
                ? PRODUCT_URL_PLACEHOLDER
                : SERVICE_URL_PLACEHOLDER
            )}
            fullWidth
            name="destinationUrl"
            variant="filled"
            size="small"
            hiddenLabel
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "fields.background",
                borderRadius: BORDER_RADIUS,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                boxShadow: BOX_SHADOW_FIELDS,
              },
            }}
          />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <IconButtonAddContent
                mode="button"
                color="secondary"
                size="small"
                disabled={
                  !item.destinationUrl || !REGEX_URL.test(item.destinationUrl)
                }
                minDimensions={MIN_DIMENSIONS_CONTENT}
                pathStorage={`adsCampaigns/${userID}/`}
                pathRTDB={`adsContentsUploaded/${userID}/${campaignID}`}
                modeUpload="sync"
                initialValues={{
                  language,
                  campaignContext,
                  websiteUrl: item.destinationUrl,
                  platform: META,
                }}
                onAddContent={(contents) => onAddMediaUrl(itemIndex, contents)}
                multiple={true}
                acceptedFormats={FORMATS_MEDIA_META.concat(
                  isCarouselAdsAvailable ? [ADS_CAMPAIGN_CAROUSEL_FORMAT] : []
                )}
                textButton={BUTTON_SELECT_CONTENT}
                sx={{
                  alignItems: "flex-start",
                }}
                sxButton={{
                  height: 36,
                  mb: 1,
                  fontSize: "0.75rem",
                }}
                destinationType={destinationType}
                propsPostsAdsPlatforms={{
                  [META]: {
                    integrationID,
                    adAccountID,
                    pageID,
                  },
                }}
              />
            </Box>

            {item.mediaUrls.length > 0 && (
              <MediaUrlsAnalysisContainer
                itemSize={100}
                mediaUrls={item.mediaUrls}
                onRemoveItem={(mediaIndex) =>
                  onRemoveMediaUrl(itemIndex, mediaIndex)
                }
                onChangeItem={({ index, data }) =>
                  onChangeMediaUrlItem(itemIndex, index, data)
                }
                objective={null}
                campaignContext={campaignContext}
                platform={META}
                disableAnalysis={true}
                suggestedCreativesCount={suggestedCreativesCount}
              />
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

const Projection = ({ fieldConfig, context, currency }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState("");
  const abortControllerRef = useRef(null);
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const { getValues, watch } = fieldConfig.utils;
  const budget = watch("budget");

  const locationsContext = context.locations || { locations: [] };
  const locations = locationsContext?.locations?.map(
    (location) => location.name
  );
  const objectContext = {
    locations,
    typeBudget: getValues("typeBudget"),
    budget: getValues("budget"),
    startDate: getValues("startDate"),
    endDate: getValues("endDate"),
    platform: META,
    currency,
  };

  const onGetInitialData = useDebounced(async () => {
    setText("");
    if (!objectContext.budget || budget < 1) return;
    abortControllerRef.current?.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;
    setIsLoading(true);
    const response = await dispatch(
      startGetAudienceProjectionAdsCampaign({
        ...objectContext,
        signal: controller.signal,
      })
    );
    if (response?.aborted) return;
    if (response.ok) {
      setText(response.data.text);
    } else {
      setText(t(ERROR_OCCURRED));
    }
    setIsLoading(false);
  }, [DELAY_DEBOUNCE * 1.5]);

  useEffect(() => {
    onGetInitialData();
    return () => abortControllerRef.current?.abort();
    // eslint-disable-next-line
  }, [budget]);

  if (!text && !isLoading) return null;

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}
    >
      {isLoading ? (
        <>
          <Skeleton variant="rectangular" width="100%" height={60} />
        </>
      ) : (
        <Typography variant="body2">{text}</Typography>
      )}
    </Box>
  );
};

const COMPONENTS = {
  objective: <ObjectiveQuestion />,
  destinationType: <DestinationTypeQuestion />,
  identities: <IdentitiesQuestion />,
  catalogID: <CatalogIDQuestion />,
  appID: <AppIDQuestion />,
  trackingID: <TrackingIDQuestion />,
  destinationURL: <DestinationURLQuestion />,
  typeBudget: <TypeBudgetQuestion />,
  budget: <BudgetQuestion />,
  dates: <DatesQuestion />,
  mediaUrls: <MediaUrlsQuestion />,
  appPromotion: <AppPromotionQuestion />,
};

const MediaUrlsSubtitle = ({ fieldConfig, t }) => {
  const subtitleText = fieldConfig.subtitle
    ? t(fieldConfig.subtitle, fieldConfig.subtitleExtrapolation)
    : "";

  if (!subtitleText) return null;

  return (
    <Box
      sx={{
        backgroundColor: GRAY_50,
        border: `1px solid ${GRAY_200}`,
        borderRadius: BORDER_RADIUS,
        width: "100%",
        p: 2,
        mb: 2,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: GRAY_900,
          fontSize: "16px",
          "& b": {
            fontWeight: 600,
            color: GRAY_900,
          },
        }}
        dangerouslySetInnerHTML={{
          __html: subtitleText,
        }}
      />
    </Box>
  );
};

const CommonQuestionContainer = ({ formConfig, fieldConfig, context }) => {
  const { t } = useTranslationApp();

  const progress = formConfig.progress;
  const { control, setValue } = fieldConfig.utils;
  const error = formConfig.error;

  const COMPONENT = COMPONENTS[fieldConfig.name];

  if (!COMPONENT) return null;

  return (
    <>
      <LinearProgress
        sx={{
          width: "100%",
          mb: 3,
          maxWidth: 600,
          backgroundColor: "rgba(0,0,0,0.2)",
          "& .MuiLinearProgress-bar": { backgroundColor: "black" },
        }}
        variant="determinate"
        value={progress}
      />
      <AnswerContainer sx={{ display: "flex", height: "100%" }}>
        <AnswerContainerTitleAndField>
          {fieldConfig.title && (
            <AnswerTitle
              sx={{ mb: 1 }}
              showButton={fieldConfig.showTitleButton}
              buttonText={fieldConfig.buttonTitleText}
              onClickButton={fieldConfig.onClickButtonTitle}
              sxButton={fieldConfig.sxButtonTitle}
              icon={fieldConfig.icon}
            >
              {`${t(fieldConfig.title, fieldConfig.titleExtrapolation)}`}
            </AnswerTitle>
          )}
          {fieldConfig.name === "mediaUrls" && fieldConfig.subtitle ? (
            <MediaUrlsSubtitle fieldConfig={fieldConfig} t={t} />
          ) : (
            fieldConfig.subtitle && (
              <AnswerSubTitle>
                {t(fieldConfig.subtitle, fieldConfig.subtitleExtrapolation)}
              </AnswerSubTitle>
            )
          )}
          {fieldConfig.customComponentBelowSubtitle
            ? fieldConfig.customComponentBelowSubtitle
            : null}
          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 1,
                backgroundColor: "fields.background",
                color: "background.paperContrastText",
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                borderRadius: BORDER_RADIUS,
                boxShadow: BOX_SHADOW_FIELDS,
              }}
            >
              {error}
            </Alert>
          )}
          {React.cloneElement(COMPONENT, {
            fieldConfig,
            control,
            setValue,
            error,
            currency: formConfig.currency,
            context,
          })}
        </AnswerContainerTitleAndField>
        {fieldConfig.showActionsButtons && (
          <ActionsButtons
            onPreviousStep={fieldConfig.onPreviousStep}
            showPreviousButton={fieldConfig.showPreviousButton}
            disabledPreviousButton={fieldConfig.disabledPreviousButton}
            onNextStep={fieldConfig.onNextStep}
            showNextButton={fieldConfig.showNextButton}
            showSkipButton={fieldConfig.showSkipButton}
            onSkipStep={fieldConfig.onSkipStep}
            disabledNextButton={fieldConfig.disabledNextButton}
            nextButtonText={fieldConfig.nextButtonText}
            saveButtonText={fieldConfig.saveButtonText}
            showSaveButton={fieldConfig.isFinishQuestion}
            disabledSaveButton={fieldConfig.disabledFinishButton}
            onFinish={fieldConfig.onFinish}
            showLoadingComponent={fieldConfig.showLoadingComponent}
            customComponentPreviousNext={
              fieldConfig.customComponentPreviousNext
            }
            customComponentBelow={fieldConfig.customComponentBelowActions}
            loading={formConfig.isCreating}
          />
        )}
      </AnswerContainer>
    </>
  );
};

export default GenerateCampaignFormMeta;
